import { useEffect, useRef, useState } from "react";
import { TableActions } from "../../components/tables/tableContext/TableContext";
import TableWidget from "../../components/tables/TableWidget";
import CustomButton from "../../components/CustomButton";
import ContentCard from "../../components/misc/ContentCard";
import { getReceipts } from "../../redux/api/receipt.api";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import ReceptionActionButtons from "./components/ReceptionActionButtons";
import ReceptionTableActionButtons from "./components/TableActionsButtonsComponents/ReceptionTableActionButtons";
import {
  getReceiptsTableData,
  receiptTableHeader,
} from "./components/tableConfigs/receptionTableConfig";
import { clearAvailableReceiptsList } from "../../redux/reducer/receipt.reducer";

type ReceptionType = 0 | 1;

function Reception() {
  const dispatch = useAppDispatch();
  const tableActionsRef = useRef<TableActions | null>(null);
  const [receptionType, setReceptionType] = useState<ReceptionType>(0);

  const {
    receipt: {
      avaibleReceiptsList: { isLoadingReceipts, data: receiptsData },
    },
  } = useAppSelector((state) => ({
    receipt: state.receipt,
  }));

  useEffect(() => {
    return () => {
      dispatch(clearAvailableReceiptsList());
    };
  }, [dispatch]);

  const loadReceipts = (action: TableActions, type: ReceptionType) => {
    if (
      action.tablePagination.page &&
      action.tablePagination.rowsPerPage &&
      action.tableSearch
    ) {
      dispatch(
        getReceipts({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          stadiu: action.tableSearch?.stadiu,
          provider: action.tableSearch?.provider,
          receptionType: type,
        }),
      );
    }
  };

  const handleTableActions = (action: TableActions) => {
    tableActionsRef.current = action;
    loadReceipts(action, receptionType);
  };

  const handleReceptionTypeChange = (type: ReceptionType) => {
    if (type === receptionType) return;

    setReceptionType(type);
    if (tableActionsRef.current) {
      loadReceipts(tableActionsRef.current, type);
    }
  };

  return (
    <div>
      <ReceptionActionButtons />
      <ContentCard>
        <div className="flex">
          <CustomButton
            variant={receptionType === 0 ? "contained" : "outlined"}
            className="w-full"
            style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            onClick={() => handleReceptionTypeChange(0)}>
            Receptii normale
          </CustomButton>
          <CustomButton
            variant={receptionType === 1 ? "contained" : "outlined"}
            className="w-full"
            style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            onClick={() => handleReceptionTypeChange(1)}>
            Receptii din AIP
          </CustomButton>
        </div>
      </ContentCard>
      <TableWidget
        tableTitle="Receptii"
        tableHeaderData={receiptTableHeader}
        tableItemsData={getReceiptsTableData(receiptsData.receptii)}
        tableLoading={isLoadingReceipts}
        handleTableActions={handleTableActions}
        totalItems={receiptsData.nrTotalReceptii}
        withGlobalSearch={false}
        ActionButtonsComponent={(props: any) => (
          <ReceptionTableActionButtons {...props} />
        )}
      />
    </div>
  );
}

export default Reception;
